import React, {Dispatch, FC, SetStateAction, useState} from 'react';
import {CustomModal} from "../../../../../../components/UI/AntCustom/CustomModal";
import {defineMessages, useIntl} from "react-intl";
import {Form, Input, message, Radio} from "antd";
import {CommonFormMessages} from "../../../../../../intl/commonMessages/CommonFormMessages";
import {CustomFieldInput} from "../../../../../../components/UI/AntCustom/CustomFieldInput";
import {CommonButtonMessages} from "../../../../../../intl/commonMessages/CommonButtonMessages";
import {CustomButton} from "../../../../../../components/UI/AntCustom/CustomButton";
import {
  IFlyHourCalculatorCategory, IFlyHourCalculatorSettingType,
  IFlyHourCalculatorSubCategory
} from "../../../../../../store/reducers/fleetReducer/fleetReducerTypes";
import {useFlyPriceCategorySetter} from "./hooks/useFlyPriceCategorySetter";
import {FlyHourPriceCalculatorSettingTypeEnum} from "./types/flyHourPriceSettingEnums";
import {onFinishTrimmed} from "../../../../../../utils/helpers/formHelpers/onFinishTrimmed";
import styled from "styled-components";


const RadioButtonsWrapper = styled.div`
  margin-bottom: 16px;
  display: flex;
  gap: 16px;
`;

const FlyHourPriceCalculatorWarnModalMessages = defineMessages({
  title: {
    id: "flyHourPriceCalculatorWarnModal.title",
    defaultMessage: "Add value"
  },
  label: {
    id: "flyHourPriceCalculatorWarnModal.label",
    defaultMessage: "Name"
  },
  placeholder: {
    id: "flyHourPriceCalculatorWarnModal.placeholder",
    defaultMessage: "Name"
  },
  fixedAmount: {
    id: "flyHourPriceCalculatorField.fix",
    defaultMessage: "Fixed amount"
  },
  percent: {
    id: "flyHourPriceCalculatorField.percent",
    defaultMessage: "In percentages"
  }
})


interface IFlyHourPriceCalculatorWarnModal {
  isModalVisible: boolean;
  setIsModalVisible: Dispatch<SetStateAction<boolean>>;
  category: IFlyHourCalculatorCategory;
  subCategory: IFlyHourCalculatorSubCategory;
}

export const FlyHourPriceCalculatorAddFieldModal: FC<IFlyHourPriceCalculatorWarnModal> = ({
                                                                                            isModalVisible,
                                                                                            setIsModalVisible,
                                                                                            category,
                                                                                            subCategory
                                                                                          }) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const categorySetter = useFlyPriceCategorySetter(category.keyName);
  const [selectedType, setSelectedType] = useState<FlyHourPriceCalculatorSettingTypeEnum>(FlyHourPriceCalculatorSettingTypeEnum.FLAT);

  const onFinish = (values: { field: string }) => {
    const newSettingType: IFlyHourCalculatorSettingType = {
      keyName: values.field,
      label: values.field,
      isEnabled: true,
      isDefault: false,
      setting: {
        value: 0,
        specificType: selectedType,
      },
      type: selectedType,
    }

    if (categorySetter) {
      categorySetter(c => {
        return {
          ...c, subcategories: c.subcategories.map(sc => {
            if (sc.keyName !== subCategory.keyName)
              return sc;
            return {...sc, settingTypes: [...sc.settingTypes, newSettingType]}
          })
        }
      })
      form.resetFields();
      setSelectedType(FlyHourPriceCalculatorSettingTypeEnum.FLAT);
      setIsModalVisible(false);
    }
  }

  const onFinishFailed = () => {
    message.error(intl.formatMessage(CommonFormMessages.incorrect))
  }

  const handleCancel = () => {
    form.resetFields();
    setSelectedType(FlyHourPriceCalculatorSettingTypeEnum.FLAT);
    setIsModalVisible(false);
  };

  return (
    <CustomModal
      title={intl.formatMessage(FlyHourPriceCalculatorWarnModalMessages.title)}
      open={isModalVisible}
      onCancel={handleCancel}
      centered={true}
      footer={null}
    >
      <Form
        form={form}
        onFinish={(values) => onFinishTrimmed(values, onFinish)}
        onFinishFailed={onFinishFailed}
        layout={'vertical'}
      >
        <CustomFieldInput
          label={intl.formatMessage(FlyHourPriceCalculatorWarnModalMessages.label)}
          name={'field'}
          rules={[
            {required: true, message: intl.formatMessage(CommonFormMessages.ruleRequired)},
          ]}>
          <Input placeholder={intl.formatMessage(FlyHourPriceCalculatorWarnModalMessages.placeholder)}/>
        </CustomFieldInput>

        <RadioButtonsWrapper>
          <Radio
            value={FlyHourPriceCalculatorSettingTypeEnum.FLAT}
            checked={selectedType === FlyHourPriceCalculatorSettingTypeEnum.FLAT}
            onClick={() => setSelectedType(FlyHourPriceCalculatorSettingTypeEnum.FLAT)}
          >
            {intl.formatMessage(FlyHourPriceCalculatorWarnModalMessages.fixedAmount)}
          </Radio>
          <Radio
            value={FlyHourPriceCalculatorSettingTypeEnum.PERCENT}
            checked={selectedType === FlyHourPriceCalculatorSettingTypeEnum.PERCENT}
            onClick={() => setSelectedType(FlyHourPriceCalculatorSettingTypeEnum.PERCENT)}
          >
            {intl.formatMessage(FlyHourPriceCalculatorWarnModalMessages.percent)}
          </Radio>
        </RadioButtonsWrapper>

        <CustomButton type={'primary'} htmlType={'submit'}
                      style={{width: "100%"}}>{intl.formatMessage(CommonButtonMessages.save)}</CustomButton>
      </Form>
    </CustomModal>
  );
};
